import { WabunkaBenefitType } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_code';

import type { WabunkaConsumerCode as ProtoWabunkaConsumerCode } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_code';

export const wabunkaCodeBenefitTypeMap = ['BENEFIT_TYPE_UNKNOWN', 'PAYMENT_SKIP', 'DISCOUNT_PERCENTAGE', 'DISCOUNT_AMOUNT', 'COMMISSION_PERCENTAGE'] as const;
export type WabunkaCodeBenefitType = (typeof wabunkaCodeBenefitTypeMap)[number];

export const buildWabunkaCodeBenefitType = (type: WabunkaBenefitType): WabunkaCodeBenefitType => {
  switch (type) {
    case WabunkaBenefitType.PAYMENT_SKIP:
      return 'PAYMENT_SKIP';
    case WabunkaBenefitType.DISCOUNT_AMOUNT:
      return 'DISCOUNT_AMOUNT';
    case WabunkaBenefitType.DISCOUNT_PERCENTAGE:
      return 'DISCOUNT_PERCENTAGE';
    case WabunkaBenefitType.COMMISSION_PERCENTAGE:
      return 'COMMISSION_PERCENTAGE';
    case WabunkaBenefitType.BENEFIT_TYPE_UNKNOWN:
    case WabunkaBenefitType.UNRECOGNIZED:
    default:
      return 'BENEFIT_TYPE_UNKNOWN';
  }
};

export interface WabunkaCode {
  codeName: string; // コード未適用時は空文字
  benefitType?: WabunkaCodeBenefitType; // 予約にコードが適用された場合のみ代入される
  benefitValue?: number; // 予約にコードが適用された場合のみ代入される
}

export const buildWabunkaCode = (d: ProtoWabunkaConsumerCode): WabunkaCode => {
  return {
    codeName: d.code,
    benefitType: buildWabunkaCodeBenefitType(d.benefitType),
    benefitValue: d.benefitValue,
  };
};

// 会計処理方式。仕様上、適用されたコードの benefitType と 1:1 で対応する
// （%割引 → 税抜ベース割引 / コミッションコード → コミッション / 定額割引 → 税込ベース割引）
export type WabunkaCodeCalculationMethod = 'TAX_EXCLUDED_DISCOUNT' | 'COMMISSION' | 'TAX_INCLUDED_DISCOUNT';

export const wabunkaCodeCalculationMethod = (code?: Pick<WabunkaCode, 'benefitType'>): WabunkaCodeCalculationMethod | undefined => {
  switch (code?.benefitType) {
    case 'DISCOUNT_PERCENTAGE':
      return 'TAX_EXCLUDED_DISCOUNT';
    case 'COMMISSION_PERCENTAGE':
      return 'COMMISSION';
    case 'DISCOUNT_AMOUNT':
      return 'TAX_INCLUDED_DISCOUNT';
    default:
      return undefined;
  }
};
